// namespace
window.Components = window.Components || {};

(function($) {

  'use strict';

  function bannerVideo() {

    var self          = this,
        $cache        = {},
        $video        = null,
        $soundButton  = null;

    /**
     * Generic resize
     */
    function onResize() {
      // Example
      if (window.bp.getLastValue() !== window.bp.getValue()) {
        if (window.bp.getValue() === 'xl') {
        }

        if (window.bp.getValue() === 'lg') {
        }

        if (window.bp.getValue() === 'md') {
        }

        if (window.bp.getValue() === 'sm') {
        }

        if (window.bp.getValue() === 'xs') {
        }
      }
    }


    function mute() {
      $video.prop('muted', true);
      console.log('mute');
      window.cache.isMute = true;
    }

    function unmute() {
      $video.prop('muted', false);
      console.log('unmute');
      window.cache.isMute = false;
    }


    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(target) {

      // Caching
      $video = $('.js-banner-video');
      $soundButton = $('.js-sound');

      //-- Video mute/unmnute
      $soundButton.on('click', function(){
        $(this).toggleClass('is-mute');
        
        if(window.cache.isMute) {
          unmute();
        } else {
          mute();
        }
      });

      window.cache.$window.on('resize', Utils.debounce(onResize, 3000));
      // Initial call on load
      onResize();
    };

    self.initialize.apply(self, arguments);
    return self;
  }
  
  window.Components.bannerVideo = bannerVideo;
  
}(jQuery));
